import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { ReceiptContent } from './ReceiptContent.component';
import { ReceiptPageControl } from './ReceiptPageControl.component';
import { useReceiptArrowKeys } from '../../hooks/useReceiptArrowKeys';
import { SideModal } from '../SideModal.component';

export const ReceiptSideModal: React.FC<
  React.PropsWithChildren<{
    modalOpen: boolean;
    setModalState: (bool: boolean) => void;
    receipts: string[];
  }>
> = ({ modalOpen, setModalState, receipts }) => {
  const [loadError, setLoadError] = React.useState(false);
  const [selectedReceiptIndex, setSelectedReceiptIndex] = React.useState(0);

  const receiptURI = receipts[selectedReceiptIndex] ?? '';

  React.useEffect(() => {
    setSelectedReceiptIndex(0);
  }, [modalOpen, receipts]);

  React.useEffect(() => {
    setLoadError(false);
  }, [receiptURI]);

  useReceiptArrowKeys(receipts.length, setSelectedReceiptIndex, modalOpen);

  function showPreviousReceipt() {
    setSelectedReceiptIndex((index) => (index - 1 + receipts.length) % receipts.length);
  }

  function showNextReceipt() {
    setSelectedReceiptIndex((index) => (index + 1) % receipts.length);
  }

  return (
    <SideModal
      modalOpen={modalOpen}
      setModalOpen={() => {
        setModalState(false);
      }}
    >
      <Layout.Column bg="grayXLight" style={{ width: '100%', height: '100%' }} px py>
        <Layout.Column grow center style={{ position: 'relative', width: '100%' }}>
          <ReceiptContent
            loadError={loadError}
            receiptURI={receiptURI}
            onError={() => setLoadError(true)}
          />
          <ReceiptPageControl
            selectedReceiptIndex={selectedReceiptIndex}
            count={receipts.length}
            onPrevious={showPreviousReceipt}
            onNext={showNextReceipt}
            style={{ position: 'absolute', bottom: 16 }}
          />
        </Layout.Column>
        <Spacer.Vertical size={12} />
        <Layout.Row center>
          <Layout.PressableRow
            onClick={() => {
              setModalState(false);
            }}
            py
            center
            bg={'brandPrimary'}
            border={[0, 'solid', 'gray']}
            radius={4}
            style={{ width: 250 }}
          >
            <OpenSans.Inverse weight="bold-700">Close</OpenSans.Inverse>
          </Layout.PressableRow>
        </Layout.Row>
      </Layout.Column>
    </SideModal>
  );
};
